/**
 * @generated SignedSource<<ef3bdd837f6008199859a8846637eb1e>>
 * @relayHash fe06e2f4a69f3231f81c25802441a1dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1

import type { ConcreteRequest } from 'relay-runtime';
export type SystemSpaceHomepageTemplate = "EAP" | "MINIMAL" | "VISUAL" | "%future added value";
export type SystemSpaceHomepageInput = {
  systemSpaceHomepageTemplate: SystemSpaceHomepageTemplate;
};
export type CreateCompanyHubSpaceMutation$variables = {
  input: SystemSpaceHomepageInput;
};
export type CreateCompanyHubSpaceMutation$data = {
  readonly createSystemSpace: {
    readonly homepageId: string | null | undefined;
    readonly id: string | null | undefined;
    readonly name: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type CreateCompanyHubSpaceMutation = {
  response: CreateCompanyHubSpaceMutation$data;
  variables: CreateCompanyHubSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "createSystemSpace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "homepageId"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CreateCompanyHubSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCompanyHubSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe06e2f4a69f3231f81c25802441a1dc",
    "id": "694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1",
    "metadata": {},
    "name": "CreateCompanyHubSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation CreateCompanyHubSpaceMutation($input:SystemSpaceHomepageInput!){createSystemSpace(input:$input){homepageId,id,name,type}}"
  }
};
})();

(node as any).hash = "6d874a2575f518173ffd31619b161569";

export default node;
